import { c as _c } from "react/compiler-runtime";
import React from "react";
import { styled } from "styled-components";
import { lightColors, OntarioColumn, OntarioRow, spacing, StepIndicator, StepIndicatorProps, zIndex } from "@ops-gsic/cxp-component-library-react";
import CreateAccountBanner from "@/components/create-account-banner";
type PageWrapperProps = {
  children: React.ReactNode;
  showCreateAccountBanner?: boolean;
  stepInfo?: StepIndicatorProps;
};
const Main = styled.main`
  position: relative;
  z-index: ${zIndex.neutral};
  width: 100%;
  margin: ${spacing.spacing0} auto;
  background-color: ${lightColors.background};
`;
export const PageWrapper = t0 => {
  const $ = _c(10);
  const {
    children,
    showCreateAccountBanner: t1,
    stepInfo
  } = t0;
  const showCreateAccountBanner = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== showCreateAccountBanner) {
    t2 = showCreateAccountBanner && <CreateAccountBanner />;
    $[0] = showCreateAccountBanner;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== stepInfo) {
    t3 = stepInfo && <OntarioRow><OntarioColumn><StepIndicator currentStep={stepInfo.currentStep} totalSteps={stepInfo.totalSteps} prevUrl={stepInfo.prevUrl} onBackClick={stepInfo.onBackClick} labels={stepInfo.labels} /></OntarioColumn></OntarioRow>;
    $[2] = stepInfo;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <Main><OntarioRow><OntarioColumn>{children}</OntarioColumn></OntarioRow></Main>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <>{t2}{t3}{t4}</>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};